import React, {useState, useMemo, ReactNode, FC} from 'react';
import {LocalizerContext, LocalizerContextValue} from './LocalizerContext';
import {localesParser, TranslationsMap} from './localesParser';

interface LocalizerProviderProps {
	//
	/**
	 * A map of language codes to it's translation maps
	 * The OBJECT MUST BE PERSISTENCE between renders
	 */
	resources: Record<string, TranslationsMap>;

	/** An initial value of the current language */
	language: string;

	children: ReactNode;
}

/**
 * Prepare and provide localization texts
 */
export const LocalizerProvider: FC<LocalizerProviderProps> = props => {
	const {resources, language: initialLanguage, children} = props;

	const [language, setLanguage] = useState(initialLanguage);

	const value = useMemo<LocalizerContextValue>(
		() => ({
			translations: localesParser(resources[language]),
			language,
			setLanguage,
		}),
		[resources, language],
	);

	return <LocalizerContext.Provider value={value}>{children}</LocalizerContext.Provider>;
};

LocalizerProvider.displayName = 'LocalizerProvider';
